import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { useStore } from "vuex";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfHeaderFooter from '@/services/utils/pdf/pdfHeaderFooter';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const pdfPrinter = () => {
    const store = useStore();
    const {commaFormat} = figureFormatter();
    const {getHeader, getFooter} = pdfHeaderFooter();

    const userName = store.state.user.user.name;

    const exportToPDF = (company, incentivePaymentData, isReport = false, isBillCollection = false) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [10, 100, 10, 80],
            header: getHeader(company),
            footer: getFooter(userName),
            content: getContent(incentivePaymentData, isReport, isBillCollection),

            styles: {
                header: {
                    fontSize: 24,
                }
            },

            defaultStyle: {
                color: 'black',
                fontSize: 8,
                font: 'SulaimanLipi'
            },

            info: {
                title: getTitle(isReport, isBillCollection),
            }
        }

        pushIntoTable(doc, incentivePaymentData, isReport, isBillCollection)

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    function getTitle(isReport, isBillCollection) {
        if (isReport && isBillCollection) return "Bill Collection Report";
        if (isReport && !isBillCollection) return "Incentive Payment Report";
        if (!isReport && isBillCollection) return "Draft Bill Collection";
        return "Draft Incentive Payment";
    }

    const getContent = (incentivePaymentData, isReport, isBillCollection) => {
        return [
            {
                text: getTitle(isReport, isBillCollection),
                style: 'header',
                alignment: 'center',
                margin: [0, 0, 20, 10],
                bold: true,
                color: 'black',
                fontSize: 12,
                decoration: 'underline'
            },

            {
                style: 'tableExample',
                margin: [0, 10, 0, 0],
                table: {
                    body: [],
                    widths: customWidth(isReport, isBillCollection)
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#f3f2f7' : null;
                    },
                    hLineWidth: function (i, node) {
                        return 0.5;
                    },
                    vLineWidth: function (i, node) {
                        return 0.5;
                    }
                }
            },
        ]
    }

    const customWidth = (isReport = false, isBillCollection) => {
        if (isBillCollection) {
            return isReport
                ? ['15%', '15%', '15%', '15%', '13%', '13%', '14%']
                : ['17%', '18%', '20%', '15%', '15%', '15%'];
        }

        return isReport
            ? ['10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%', '10%']
            : ['12%', '13%', '15%', '10%', '10%', '10%', '10%', '10%', '10%'];
    }

    const pushIntoTable = (doc, incentivePaymentData, isReport, isBillCollection) => {
        const tableItems = Array.isArray(incentivePaymentData.data.data)
            ? incentivePaymentData.data.data
            : Object.values(incentivePaymentData.data.data);
        const tableHeader = getTableHeader(isReport, isBillCollection);
        doc.content[1].table.body.push(tableHeader);

        tableItems.forEach((item, i) => {
            const rowData = getRowData(item, i, isReport, isBillCollection);
            doc.content[1].table.body.push(rowData);

            const detailsRow = getRowDetails(item.item_details || '', isReport, isBillCollection);
            doc.content[1].table.body.push(detailsRow);
        });

        const getLastRow = getTotal(incentivePaymentData.data.total, isReport, isBillCollection)
        doc.content[1].table.body.push(getLastRow);
    }

    const getRowDetails = (itemDetails, isReport, isBillCollection) => {
        let colSpanValue = isReport ? 10 : 9;
        let emptyCells   = isReport ? 9 : 8;

        if (isBillCollection && isReport) {
            colSpanValue = 7;
            emptyCells   = 6;
        }

        if (isBillCollection && !isReport) {
            colSpanValue = 6;
            emptyCells   = 5;
        }

        return [
            { text: itemDetails, colSpan: colSpanValue },
            ...Array(emptyCells).fill({})
        ];
    };

    const getTableHeader = (isReport, isBillCollection) => {
        let tableHeader = [
            {text: 'Invoice Date'},
            {text: 'Invoice No'},
            {text: 'Patient Name (ID)'},
            {text: 'Total Bill', alignment: 'right'},
            {text: 'Total Discount', alignment: 'right'},
            {text: 'Net Bill', alignment: 'right'},
        ];

        if (isBillCollection && isReport){
            tableHeader.unshift({text: 'Client Name'});
            return tableHeader;
        }

        if (isBillCollection && !isReport){
            return tableHeader;
        }

        tableHeader.push(
            {text: 'Total Incentive', alignment: 'right'},
            {text: 'Referrer Discount', alignment: 'right'},
            {text: 'Net Incentive', alignment: 'right'},
        )

        if (isReport) {
            tableHeader.unshift({text: 'Referrer'});
        }

        return tableHeader;
    }

    const getRowData = (item, i, isReport, isBillCollection) => {
        const tableRow = [
            {text: item.date},
            {text: item.bill_number}
       ];

       if (isBillCollection){
           tableRow.push(
               {text: item.contact_profile_name + '(' + item.contact_profile_serial_no + ')' },
           )
       }

        if (!isBillCollection){
            tableRow.push(
                {text: item.patient_name + '(' + item.patient_serial_no + ')' }
            )
        }

        tableRow.push(
            {text: commaFormat(item.subtotal_amount), alignment: 'right'},
            {text: commaFormat(item.total_discount), alignment: 'right'},
            {text: commaFormat(item.total_amount), alignment: 'right'},
        )

        if (isBillCollection && isReport){
            tableRow.unshift({text: item.client_profile_name + '(' + item.client_serial_no + ')'});
            return tableRow;
        }

        if (isBillCollection && !isReport){
            return tableRow;
        }

        tableRow.push(
            {text: commaFormat(item.incentive_amount), alignment: 'right'},
            {text: commaFormat(item.referrer_discount_amount), alignment: 'right'},
            {text: commaFormat(item.net_incentive), alignment: 'right'},
        )

        if (isReport) {
            tableRow.unshift({text: item.referrer_name + '(' + item.referrer_serial_no + ')'});
        }

        return tableRow
    }

    const getTotal = (totalValue, isReport, isBillCollection) => {
        let colSpanValue = isReport ? 4 : 3;
        let emptyCells = isReport ? 3 : 2;

        if (isBillCollection && isReport){
            colSpanValue = 4;
            emptyCells =  3
        }

        if (isBillCollection && !isReport){
            colSpanValue = 3;
            emptyCells =  2
        }

          const lastRow = [
                {
                    text: 'Total',
                    alignment: 'right',
                    colSpan: colSpanValue
                },

                 ...Array(emptyCells).fill({}),

                {
                    text: totalValue.total_invoice,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_discount,
                    alignment: 'right'
                },

                {
                    text: totalValue.net_bill,
                    alignment: 'right'
                },
            ]

            if (isBillCollection && (!isReport || isReport)){
                return lastRow
            }

            lastRow.push(
                {
                    text: totalValue.total_incentive,
                    alignment: 'right'
                },

                {
                    text: totalValue.total_referrer_discount,
                    alignment: 'right'
                },

                {
                    text: totalValue.net_incentive,
                    alignment: 'right'
                }
            )

        return lastRow
    }

    return {
        exportToPDF
    }

}

export default pdfPrinter;